import React, {
  useState,
  useEffect,
} from 'react';
import Button from 'pages/Dashboard/components/Button';
import {
  useTableReset,
} from 'core/hooks';
import AddContactIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from 'core/icons/search';
import SearchInput from 'pages/Dashboard/components/SearchInput';
import {
  useSyncSearchQuery,
} from 'pages/Dashboard/hooks/url';
import Overview from 'pages/Dashboard/pages/Contacts/Overview';
import {
  faxEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import isNil from 'lodash/isNil';
import ContactsForm from 'pages/Dashboard/pages/Contacts/ContactForm';

export default function Contacts() {
  const {
    reset,
    tableInstanceRef,
  } = useTableReset();
  const [contactDialogParams, setContactDialogParams] = useState<any | null>(null);
  const {
    searchQuery,
    setSearchQuery,
  } = useSyncSearchQuery();

  useEffect(() => {
    const unsubscribeToOpen = faxEventChannel.on('onOpenContacts', (contact) => {
      setContactDialogParams({ contact });
    });
    const unsubscribeFromUpdate = faxEventChannel.on('onContactChange', () => {
      tableInstanceRef?.current?.refetch?.();
    });

    return () => {
      unsubscribeToOpen();
      unsubscribeFromUpdate();
    };
  }, []);

  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex items-start px-4">
        <div className="w-full flex flex-row justify-start gap-4 mb-4">
          <SearchInput
            placeholder="Enter Contact Name or Phone"
            className="w-96"
            value={searchQuery}
            onChange={(val) => {
              setSearchQuery(val);
              reset();
            }}
            inputProps={{
              autoComplete: 'off',
            }}
            icon={<SearchIcon className="!w-4 !h-4 text-gray-400" />}
            id="patient-search"
          />
        </div>
        <Button
          className="!h-8"
          variant="contained"
          type="button"
          color="primary"
          startIcon={<AddContactIcon className="!w-4 !h-4" />}
          onClick={() => {
            setContactDialogParams({});
          }}
        >
          Add Contact
        </Button>
      </div>
      <Overview
        searchQuery={searchQuery}
        tableInstanceRef={tableInstanceRef}
      />
      {!isNil(contactDialogParams) && (
        <ContactsForm
          {...contactDialogParams}
          open
          onClose={() => { setContactDialogParams(null); }}
        />
      )}
    </div>
  );
}
